import React from 'react'

import { SignaturePreviewModalUI } from './SignaturePreviewModalUI'
import { lang } from 'utils/helpers'

const SignaturePreviewModal = ({ isOpen, toggle, signature }) => {
  const template = {
    content: `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
      eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
      ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
      aliquip ex ea commodo consequat.
      \n\n
      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
      dolore eu fugiat nulla pariatur.
    `,
    contentHtml: `
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
      eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
      ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
      aliquip ex ea commodo consequat.</p>
      <br>
      <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
      dolore eu fugiat nulla pariatur.</p>
    `,
    attachments: [
      {
        mimeType: 'image',
        url: 'https://dev.v2.l1l.co/i-ysbPlQ',
        urlLong: 'https://files.dev.v2.l1l.co/a02e327639e59cd7b850869877fd845c5d6e5dbda544a322f2b78fcec39e901d/2022-01/dashboard-1643144451574-379cebd11a2f.jpg'
      }
    ],
    buttons: [
      {
        content: 'https://dev.v2.l1l.co/Bdpalgqr',
        label: `${lang('dashboard_button')} 1`,
        type: 'url'
      },
      {
        content: 'https://dev.v2.l1l.co/Bdpalgqr',
        label: `${lang('dashboard_button')} 2`,
        type: 'url'
      }
    ],
    signature
  }

  return (
    <SignaturePreviewModalUI
      isOpen={isOpen}
      toggle={toggle}
      channel='chatmail'
      template={template}
    />
  )
}

export { SignaturePreviewModal }
